<template>
  <!-- 技改项目管理 -->
  <div class="rightbox backwhite width86 border-rd3" style="min-height: 800px">
    <div class="toolbtn flex margin-right10">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="200">
      <template slot="template">
        <p
          class="
            flex-betweennowrap
            width98
            margin-auto margin-top20 margin-bot10
          "
        >
          <span class="dimensional">技改项目管理</span>
          <span class="attention f14" @click="tocollectionadd()">新 增</span>
        </p>

        <el-table
          :data="page"
          stripe
          class="eltable width98 margin-auto f14"
          v-if="total != 0"
        >
          <el-table-column label="资产名称" align="left">
            <template slot-scope="scope">
              <span
                class="width100 cursorpointer bluecolor"
                @click="previewreport(scope.row)"
                >{{ scope.row.title }}
              </span></template
            >
          </el-table-column>
          <el-table-column label="投资金额" align="center">
            <template slot-scope="scope">
              {{
                scope.row.price == "" || null
                  ? 0 + "万元"
                  : scope.row.price + "万元"
              }}</template
            ></el-table-column
          >
          <el-table-column label="备案状态" align="center" prop="record" />
          <el-table-column label="项目状态" align="center" prop="status_text" />
          <el-table-column label="立项时间" align="center" prop="start_at" />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span class="bluecolor" @click="previewreport(scope.row)"
                  >详情</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="collectionmodify(scope.row)"
                  >修改</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="designDetail(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            width98
            margin-auto
            pad-top20 pad-bot20 pad-left10 pad-right10
          "
          v-if="total != 0"
        >
          <span class="f14" style="color: #409eff"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 详情 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisibledetail"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">技改项目管理</div>
      <div class="margon-auto margin-top30">
        <div class="table">
          <div class="leftboxs">立项时间 :</div>
          <div class="rightboxs">{{ start_at }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">项目名称 :</div>
          <div class="rightboxs">{{ title }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">投资额度 :</div>
          <div class="rightboxs">{{ price }} 万</div>
        </div>
        <div class="table">
          <div class="leftboxs">项目进度 :</div>
          <div class="rightboxs">{{ status }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">备案状态 :</div>
          <div class="rightboxs">{{ record }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">备注 :</div>
          <div class="rightboxs">{{ remark }}</div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibledetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">技改项目新增</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>项目名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入项目名称"
              v-model="title"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>投资金额</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入投资金额 单位万元"
              v-model="price"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>备案状态</div>
          <div class="box-right">
            <el-select
              v-model="record"
              placeholder="请选择备案状态"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div>项目状态</div>
          <div class="box-right">
            <el-select
              v-model="status"
              placeholder="请选择项目状态"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div>立项时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="start_at"
              type="date"
              placeholder="请选择研发立项日期"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">技改项目修改</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>项目名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入项目名称"
              v-model="title"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>投资金额</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入投资金额 单位万元"
              v-model="price"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>备案状态</div>
          <div class="box-right">
            <el-select
              v-model="record"
              placeholder="请选择备案状态"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <div>项目状态</div>
          <div class="box-right">
            <el-select
              v-model="status"
              placeholder="请选择项目状态"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <div>立项时间</div>
          <div class="box-right">
            <!-- <input class="inputDeep" v-model="start_date" /> -->
            <el-date-picker
              class="inputDeep"
              v-model="start_at"
              type="date"
              placeholder="请选择研发立项日期"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>
          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button class="" type="primary" @click="Savechangemodify()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  enttechupgradeindex,
  enttechupgradedelete,
  enttechupgradedetail,
  enttechupgradesave,
  enttechupgradeupdate,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      dialogVisibledetail: false,
      title: "",
      start_at: "",
      price: "",
      status: "",
      record: "",
      // level: "",
      remark: "",
      nums: 200,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      modifyid: "",
      options: [
        {
          value: "1",
          label: "筹备",
        },
        {
          value: "2",
          label: "立项",
        },
        {
          value: "3",
          label: "研发",
        },
        {
          value: "4",
          label: "结项",
        },
        {
          value: "5",
          label: "完成",
        },
      ],
      optionss: [
        {
          value: 0,
          label: "未备案",
        },
        {
          value: 1,
          label: "已备案",
        },
      ],
    };
  },
  components: {
    callback,
  },
  methods: {
    monitorInputs() {
      var txtVal = this.remark.length;
      this.nums = txtVal;
    },
    // 详情
    previewreport(row) {
      this.dialogVisibledetail = true;
      enttechupgradedetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.start_at = res.data.data.start_at;
          if (res.data.data.record == 0) {
            this.record = "未备案";
          } else {
            this.record = "已备案";
          }
          // this.status = res.data.data.status;
          if (res.data.data.status == 1) {
            this.status = "筹备";
          } else if (res.data.data.status == 2) {
            this.status = "立项";
          } else if (res.data.data.status == 3) {
            this.status = "研发";
          } else if (res.data.data.status == 4) {
            this.status = "结项";
          } else if (res.data.data.status == 5) {
            this.status = "完成";
          }
          this.price = res.data.data.price;
          this.remark = res.data.data.remark;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    tocollectionadd() {
      this.dialogVisibleadd = true;
      this.title = "";
      this.price = "";
      this.status = "";
      this.remark = "";
      this.start_at = "";
      this.record = "";
      this.nums = 200;
    },
    Savechanges() {
      enttechupgradesave({
        title: this.title,
        start_at: this.start_at,
        record: this.record,
        status: this.status,
        price: this.price,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 修改
    collectionmodify(row) {
      this.dialogVisiblemodify = true;
      this.modifyid = row.id;
      enttechupgradedetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.start_at = res.data.data.start_at;
          if (res.data.data.record == 0) {
            this.record = "未备案";
          } else {
            this.record = "已备案";
          }
          // this.status = res.data.data.status;
          if (res.data.data.status == 1) {
            this.status = "筹备";
          } else if (res.data.data.status == 2) {
            this.status = "立项";
          } else if (res.data.data.status == 3) {
            this.status = "研发";
          } else if (res.data.data.status == 4) {
            this.status = "结项";
          } else if (res.data.data.status == 5) {
            this.status = "完成";
          }
          this.price = res.data.data.price;
          this.remark = res.data.data.remark;
          this.nums = 200 - this.remark.length;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Savechangemodify() {
      if (this.record == "未备案") {
        this.record = 0;
      } else if (this.record == "已备案") {
        this.record = 1;
      }
      if (this.status == "筹备") {
        this.status = 1;
      } else if (this.status == "立项") {
        this.status = 2;
      } else if (this.status == "研发") {
        this.status = 3;
      } else if (this.status == "结项") {
        this.status = 4;
      } else if (this.status == "完成") {
        this.status = 5;
      }
      enttechupgradeupdate({
        id: this.modifyid,
        title: this.title,
        start_at: this.start_at,
        record: this.record,
        status: this.status,
        price: this.price,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除项目
    designDetail(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          enttechupgradedelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      enttechupgradeindex({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.record == 0) {
              i.record = "未备案";
            } else if (i.record == 1) {
              i.record = "已备案";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      enttechupgradeindex({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.record == 0) {
              i.record = "未备案";
            } else if (i.record == 1) {
              i.record = "已备案";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      enttechupgradeindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.record == 0) {
              i.record = "未备案";
            } else if (i.record == 1) {
              i.record = "已备案";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    enttechupgradeindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.record == 0) {
            i.record = "未备案";
          } else if (i.record == 1) {
            i.record = "已备案";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
      <style scoped>
.table {
  width: 98%;
  display: flex;
  margin: auto;
  text-align: left;
  font-size: 14px;
  color: #4f4f4f;
  line-height: 40px;
}
.leftboxs {
  min-width: 70px;
  color: #353a44;
  padding: 0 0 0 5px;
}
.rightboxs {
  margin-left: 10px;
  color: #6a7589;
  padding: 0 0 0 5px;
}

/* 表单盒子 */
.bg-box {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 10px 0;
  color: #4f4f4f;
  font-size: 14px;
}
.inputDeep {
  width: 100%;
}
.box-right {
  padding-top: 5px;
  width: 100%;
  position: relative;
}
.el-select {
  width: 100%;
}
.el-input-number--small {
  width: 100%;
}
.textarea {
  width: 170%;
  height: 80px;
  border: 1px solid #efefef;
  outline: none;
  padding: 10px 0 0 5px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__header {
  text-align: left;
}
.errorboxs >>> .el-dialog__title {
  text-align: left;
  font-size: 16px;
  color: #606266;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f1f3f9;
  height: 40px;
  font-size: 14px;
  border-radius: 3px;
}
</style>